// Third party modules;
import React from 'react';

const Drop = (props) => {

   const dropdown_list = React.useRef();

   const click = (e) => {
      // Set the drop down content display to 'none' so it disapears, then in 0.1 seconds
      // set display mode to '' so that the next hover will cause it to drop down;
      if (dropdown_list && dropdown_list.current) {
         dropdown_list.current.style.display = 'none';
         setTimeout(
            () => {
               if (dropdown_list && dropdown_list.current) dropdown_list.current.style.display = '';
            },
            100
         );
         if (props.callback) {
            props.callback(props.list[e.target.dataset.index]);
         }
      }
   } // click();

   const content = [];

   const list    = props.list;

   const prefix  = props.prefix;

   for (var ith = 1; ith < list.length; ith++) {
      content.push(<div data-index={ith} key={ith} onClick={click}>{list[ith]}</div>);
   }

   return(
      <div className={`${prefix}`} style={props.style}>
        <div className={`${prefix}-text`} data-index={0} onClick={click}>{list[0]}</div>
        <div className={`${prefix}-list`} ref={dropdown_list} style={props.list_style}>{content}</div>
      </div>
   );

} // <Drop />

export default Drop;